import {
  // -- GET (array of objects)
  GET_ACCOUNTS_SUCCESS,
  GET_ACCOUNTS_FAILURE,
  // -- GET (one object)
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_FAILURE,
  // -- GET (one object)
  GET_ACCOUNT_RIGHTS_SUCCESS,
  GET_ACCOUNT_RIGHTS_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

let cacheItemList = null
let cacheItems = null

export const account = (state = {}, action) => {
  switch (action.type) {
    // -- GET (array of objects)
    case GET_ACCOUNTS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] account.GET_ACCOUNTS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_ACCOUNTS_SUCCESS: {
      cacheItemList = action.data || []
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] account.GET_ACCOUNTS_SUCCESS()', { state, action })
      return {
        ...state,
        items: cacheItemList
      }
    }

    // -- GET (one object)
    case GET_ACCOUNT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] account.GET_ACCOUNT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_ACCOUNT_SUCCESS: {
      cacheItems = action.data || []
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] account.GET_ACCOUNT_SUCCESS()', { state, action })
      return {
        ...state,
        items: cacheItems
      }
    }

    // -- GET (one object)
    case GET_ACCOUNT_RIGHTS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] account.GET_ACCOUNT_RIGHT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_ACCOUNT_RIGHTS_SUCCESS: {
      cacheItems = action.data || []
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] account.GET_ACCOUNT_RIGHT_SUCCESS()', { state, action })
      return {
        ...state,
        items: cacheItems
      }
    }

    default:
      return state
  }
}
